import { Format, PageLoader, useApiAction } from "@redriver/cinnamon";
import { Panel } from "components/containers";
import moment from "moment";
import React, { useMemo } from "react";
import { Tab } from "semantic-ui-react";
import { getBookingOverview } from "./actions";
import BookingDetailsPanel from "./BookingDetailsPanel";
import PassengerInfoPanel from "./PassengerInfoPanel";
import DocumentsPanel from "./DocumentsPanel";
import BookingRefContext from "./BookingRefContext";

const BookingDetails = ({ bookingId }) => {
  const [{ response, busy }] = useApiAction(getBookingOverview, {
    lazy: false,
    actionParams: bookingId,
  });

  const booking = response;

  const daysDuration = useMemo(() => {
    if (!response) {
      return 0;
    }
    return moment(response.return).diff(moment(response.departure), "days");
  }, [response]);

  const tabs = [
    {
      menuItem: "Details",
      render: () => <BookingDetailsPanel bookingId={bookingId} />,
    },
    {
      menuItem: "Passenger Info",
      render: () => <PassengerInfoPanel bookingId={bookingId} />,
    },
    {
      menuItem: "Documents",
      render: () => <DocumentsPanel bookingId={bookingId} />,
    },
  ];

  if (busy || !booking) {
    return <PageLoader />;
  }

  return (
    <div className="booking-details" style={{ margin: "0 0.5em" }}>
      <BookingRefContext.Provider value={booking.ref}>
        <Panel border="left" className="booking-overview mid-blue">
          <div className="booking-header">
            <div>
              <span className="booking-ref" style={{ marginRight: "1em" }}>
                {booking.ref}
              </span>
              <span>{booking.customer}</span>
            </div>
            <span>
              {`${booking.typeName} ${
                booking.destination ? "to " + booking.destination : ""
              }`}
            </span>
          </div>
          <p style={{ marginTop: "1em" }}>
            Departure <Format.Date value={booking.departure} /> for{" "}
            {daysDuration} days by {booking.transportMethodName} for{" "}
            {booking.passengerCount} people
          </p>
        </Panel>
        <Tab className="tabs" menu={{ secondary: true }} panes={tabs} />
      </BookingRefContext.Provider>
    </div>
  );
};

export default BookingDetails;
